/**
 *  リンククリックで詳細ページをポップアップ表示する
 **/

$(document).ready( function() { 
  'use strict';

 
  /**
   * リンクへ詳細表示のポップアップ表示を適用する
   **/
  function applyPopupDetails (content,event ) {
    var url = $(content).attr('href');
    //console.log( 'popup', url );

    try { 
      $.ajax( {
        url : url,
        type : 'GET',
      })
      .done( function( result ) {
        var content = $(result).find('.entry-content');
        var popup_content = content.find('.popup-contents');
        if ( popup_content.length !== 0  ) { 
          content = popup_content;
        }
        content.find('.moko-ad').remove();
        $('#modal-dialog .modal-body').html( content.html() );
        $('#modal-dialog').modal();

        $('#modal-dialog .btn-detail').attr('href',url);
        //alert(content);

        var new_content = $('#modal-dialog .modal-body');
        moko.initPolls( new_content );
        moko.initDataTables( new_content );
        if (window.moko && typeof moko.loadOperationsFragments === 'function') {
          moko.loadOperationsFragments(new_content.get(0));
        }
      })
      .fail( function() {
        location.href = url;
      });
    } catch ( ex ) {
      location.href = url;
    }


    event.preventDefault();
  }

  $(document).on('click','.popup-details a, a.popup-details', function( e ) {  applyPopupDetails( this, e ); } );


});
